// Module
var code = "<h2 id=\"phone\">Phone</h2> <p>Call us to make payments at any time and learn what you need to have on-hand.</p> ";
// Exports
export default code;